// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3wgbd","label":"Labeled_label__1EKeq","divider":"Labeled_divider__2txFR"};